import { useCallback, useReducer } from 'react'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import effects from 'app/effects/effects'
import MessageAlert from 'app/components/MessageAlert'

export const ActionType = {
  SET_POLL_OPTIONS: 'SET_POLL_OPTIONS',
  SET_POLL_VOTERS: 'SET_POLL_VOTERS',

  SET_LOADER_POLL_DETAIL: 'SET_LOADER_POLL_DETAIL',
  SET_LOADER_VOTERS: 'SET_LOADER_VOTERS',
}

const initialState = {
  voters: [],
  pollDetail: {},
  isLoadingVoters: false,
  isLoadingPollDetail: false,
}

const reducer = (state, action) => {
  switch (action.type) {
    case ActionType.SET_LOADER_POLL_DETAIL:
      return {
        ...state,
        isLoadingPollDetail: action.value,
      }
    case ActionType.SET_POLL_OPTIONS:
      return {
        ...state,
        pollDetail: action.value,
        isLoadingPollDetail: false,
      }
    case ActionType.SET_LOADER_VOTERS:
      return {
        ...state,
        isLoadingVoters: action.value,
      }
    case ActionType.SET_POLL_VOTERS:
      return {
        ...state,
        voters: action.value,
        isLoadingVoters: false,
      }
    default:
      return state
  }
}

export default function usePoll() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { formatMessage } = useIntl()
  const commonDispatch = useDispatch()

  const handleAlertError = useCallback(() => {
    return commonDispatch(
      MessageAlert.showError({
        message: formatMessage({
          id: 'error.general',
        }),
      }),
    )
  }, [commonDispatch, formatMessage])

  const fetchPollDetail = (id, pollId, languageId) => {
    effects.apis
      .pollByNotification(id, pollId, languageId)
      .then((response) => {
        dispatch({ type: 'SET_POLL_OPTIONS', value: response })
      })
      .catch(() => handleAlertError())
  }

  const handleFetchPollDetail = (id, pollId, languageId) => {
    dispatch({ type: 'SET_LOADER_POLL_DETAIL', value: true })
    fetchPollDetail(id, pollId, languageId)
  }

  const fetchVoters = (pollId, optionId, languageId) => {
    effects.apis
      .pollVoter(pollId, optionId, languageId)
      .then((response) => {
        dispatch({ type: 'SET_POLL_VOTERS', value: response })
      })
      .catch(() => handleAlertError())
  }

  const handleFetchVoters = (pollId, optionId, languageId = null) => {
    dispatch({ type: 'SET_LOADER_VOTERS', value: true })
    fetchVoters(pollId, optionId, languageId)
  }

  return {
    state,
    handleFetchPollDetail,
    handleFetchVoters,
  }
}
